import CreditDashboard from './Index.vue';

export const routes = [
  {
    path: 'dashboard-credito',
    name: 'talkvia_credit_dashboard',
    meta: {
      permissions: ['administrator'],
      superAdminOrAdmin: true,
    },
    component: CreditDashboard,
  },
];
